import React from 'react';
import { AlternativesSection } from '../../proposal/sections/dach/AlternativesSection';
import { NextStepsSection } from '../../proposal/sections/dach/NextStepsSection';
import { FAQSection } from '../../proposal/sections/dach/FAQSection';
import { CTASection } from '../../proposal/sections/dach/CTASection';
import { PageFooterDach } from './ContentPage2Dach';
import { DACH_DATA } from '../../proposal/data/dachData';
import { DraggableElement } from '../../DraggableElement';

/**
 * Page 4 (A4) – Alternativen + Schritte + FAQ + CTA.
 * Composer: setzt 4 Sections zusammen.
 */
export const ContentPage4Dach = ({ editMode, textEditMode = false, layoutEditLevel, proposalData = DACH_DATA, textContent, onTextChange, showMarkers = true, selectedElements, elementPositions, onSelectElement, onPositionChange }) => {
  const dragProps = {
    editMode,
    selectedElements,
    elementPositions,
    onSelectElement,
    onPositionChange,
    dragAxis: 'y',
    showMarkers,
  };

  return (
    <div className="a4-page" data-testid="page-4-dach" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {layoutEditLevel === 'detail' ? (
        <AlternativesSection
          ansprechpartner={proposalData.ansprechpartner}
          telefon={proposalData.telefonnummer}
          email={proposalData.email}
          content={textContent?.alternatives || proposalData.text?.alternatives || DACH_DATA.text?.alternatives}
          onTextChange={onTextChange}
          editMode={textEditMode}
          layoutEditLevel={layoutEditLevel}
          dragProps={dragProps}
        />
      ) : (
        <DraggableElement id="S4-Alternativen" {...dragProps}>
          <AlternativesSection
            ansprechpartner={proposalData.ansprechpartner}
            telefon={proposalData.telefonnummer}
            email={proposalData.email}
            content={textContent?.alternatives || proposalData.text?.alternatives || DACH_DATA.text?.alternatives}
            onTextChange={onTextChange}
            editMode={textEditMode}
          />
        </DraggableElement>
      )}

      {layoutEditLevel === 'detail' ? (
        <NextStepsSection
          content={textContent?.page4?.nextSteps || proposalData.text?.page4?.nextSteps || DACH_DATA.text?.page4?.nextSteps}
          onTextChange={onTextChange}
          editMode={textEditMode}
          layoutEditLevel={layoutEditLevel}
          dragProps={dragProps}
        />
      ) : (
        <DraggableElement id="S4-Naechste-Schritte" {...dragProps}>
          <NextStepsSection
            content={textContent?.page4?.nextSteps || proposalData.text?.page4?.nextSteps || DACH_DATA.text?.page4?.nextSteps}
            onTextChange={onTextChange}
            editMode={textEditMode}
          />
        </DraggableElement>
      )}

      {layoutEditLevel === 'detail' ? (
        <FAQSection
          content={textContent?.page4?.faq || proposalData.text?.page4?.faq || DACH_DATA.text?.page4?.faq}
          onTextChange={onTextChange}
          editMode={textEditMode}
          layoutEditLevel={layoutEditLevel}
          dragProps={dragProps}
        />
      ) : (
        <DraggableElement id="S4-FAQ" {...dragProps}>
          <FAQSection
            content={textContent?.page4?.faq || proposalData.text?.page4?.faq || DACH_DATA.text?.page4?.faq}
            onTextChange={onTextChange}
            editMode={textEditMode}
          />
        </DraggableElement>
      )}

      {layoutEditLevel === 'detail' ? (
        <CTASection
          ansprechpartner={proposalData.ansprechpartner}
          telefon={proposalData.telefonnummer}
          email={proposalData.email}
          gueltigBis={proposalData.gueltig_bis}
          content={textContent?.page4?.cta || proposalData.text?.page4?.cta || DACH_DATA.text?.page4?.cta}
          onTextChange={onTextChange}
          editMode={textEditMode}
          layoutEditLevel={layoutEditLevel}
          dragProps={dragProps}
        />
      ) : (
        <DraggableElement id="S4-CTA" {...dragProps}>
          <CTASection
            ansprechpartner={proposalData.ansprechpartner}
            telefon={proposalData.telefonnummer}
            email={proposalData.email}
            gueltigBis={proposalData.gueltig_bis}
            content={textContent?.page4?.cta || proposalData.text?.page4?.cta || DACH_DATA.text?.page4?.cta}
            onTextChange={onTextChange}
            editMode={textEditMode}
          />
        </DraggableElement>
      )}

      <PageFooterDach page={4} />
    </div>
  );
};
